import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { SubtypeState } from "../../../../types/actionModule/editor/subtypeEditorTypes"
import { DateModuleSubtypeResponse } from "../../../../types/actionModule/subtypes/dateSubtype";
import dayjs from "dayjs";

interface Props {
    state: SubtypeState
}

export default function DateEditorPreview(props: Props) {
    const subtype = props.state.properties as Partial<DateModuleSubtypeResponse>
    const value = subtype.autoFillWithCurrentDate ? dayjs() : null;

    return <DatePicker
        value={value}
        onChange={() => { }} />
}